export const selectAuthUser = state => state.auth.user